// Category master list.
//
// `tiktok` = handle without the leading '@'. If empty/null, the category is
// treated as "Under Development" and rendered smaller + dimmer on the landing.
// `priority` controls both sort order AND size tier on the landing page:
//   1..3   → tier "large"   (top 3 cards, biggest)
//   4..8   → tier "medium"  (next 5 cards)
//   9..11  → tier "regular" (next 3 cards)
//   999    → tier "dev"     (no tiktok, smallest)
export const CATEGORIES = [
  {
    name: 'Buddhist Match',
    color: '#F59E0B',
    tiktok: 'buddhistmatch.id',
    priority: 1,
    en: 'For Buddhist singles seeking meaningful connections',
    id: 'Untuk jomblo Buddhist yang mencari koneksi bermakna',
    detail_en: 'Buddhist Match connects singles who follow the Buddhist faith — whether Theravada, Mahayana, Vajrayana, Zen, or other traditions. This category is ideal for those seeking a partner who shares Buddhist values such as mindfulness, compassion, and spiritual growth. Open to all Buddhist denominations and practitioners at any stage of their spiritual journey.',
    detail_id: 'Buddhist Match menghubungkan jomblo yang menganut agama Buddha — baik Theravada, Mahayana, Vajrayana, Zen, atau tradisi lainnya. Kategori ini cocok bagi mereka yang mencari pasangan yang berbagi nilai-nilai Buddhist seperti kesadaran penuh, kasih sayang, dan pertumbuhan spiritual. Terbuka untuk semua aliran Buddhist dan praktisi di tahap mana pun dalam perjalanan spiritual mereka.',
  },
  {
    name: 'Catholic Match',
    color: '#6366F1',
    tiktok: 'katholikmatch.id',
    priority: 2,
    en: 'For Catholic singles united by faith and values',
    id: 'Untuk jomblo Katolik yang disatukan oleh iman dan nilai',
    detail_en: 'Catholic Match brings together Catholic singles who are guided by their faith and the teachings of the Church. This category welcomes both Roman Catholics and Eastern Catholics who seek a partner rooted in sacramental life, devotion, and shared Catholic values. Finding love through faith.',
    detail_id: 'Catholic Match menyatukan jomblo Katolik yang dibimbing oleh iman mereka dan ajaran Gereja. Kategori ini menyambut Katolik Roma dan Katolik Timur yang mencari pasangan yang berakar dalam kehidupan sakramental, devosi, dan nilai-nilai Katolik bersama. Menemukan cinta melalui iman.',
  },
  {
    name: 'Tenglang Match',
    color: '#DC2626',
    tiktok: 'tenglangmatch.id',
    priority: 3,
    en: 'For Chinese-Indonesian singles connecting with community',
    id: 'Untuk jomblo Tionghoa-Indonesia yang terhubung dengan komunitas',
    detail_en: 'Tenglang Match is specifically for Chinese-Indonesian (Tionghoa-Indonesia) singles who want to connect with others from the same cultural background. This category celebrates the unique blend of Chinese heritage and Indonesian identity, helping you find a partner who understands your cultural nuances.',
    detail_id: 'Tenglang Match khusus untuk jomblo Tionghoa-Indonesia yang ingin terhubung dengan sesama dari latar belakang budaya yang sama. Kategori ini merayakan perpaduan unik warisan Tionghoa dan identitas Indonesia, membantu Anda menemukan pasangan yang memahami nuansa budaya Anda.',
  },
  {
    name: 'Zona Taaruf',
    color: '#10B981',
    tiktok: 'zona.taaruf.id',
    priority: 4,
    en: 'Islamic matchmaking following taaruf principles',
    id: 'Perjodohan Islami mengikuti prinsip taaruf',
    detail_en: 'Zona Taaruf facilitates Islamic matchmaking following the taaruf (getting to know each other) process as guided by Islamic principles. This category is for Muslim singles who wish to find a halal partner through a respectful, transparent process. Suitable for Sunni, Syiah, NU, Muhammadiyah, and all Muslim backgrounds committed to building a family based on Islamic values.',
    detail_id: 'Zona Taaruf memfasilitasi perjodohan Islami mengikuti proses taaruf (saling mengenal) sesuai prinsip Islam. Kategori ini untuk jomblo Muslim yang ingin menemukan pasangan halal melalui proses yang hormat dan transparan. Cocok untuk Sunni, Syiah, NU, Muhammadiyah, dan semua latar belakang Muslim yang berkomitmen membangun keluarga berdasarkan nilai-nilai Islam.',
  },
  {
    name: 'Christian Match',
    color: '#3B82F6',
    tiktok: 'kristenmatch.id',
    priority: 5,
    en: 'For Christian singles looking for a faithful partner',
    id: 'Untuk jomblo Kristen yang mencari pasangan setia',
    detail_en: 'Christian Match is designed for Protestant Christian singles seeking a partner who shares their faith in Christ. This includes all Protestant denominations — Reformed, Lutheran, Methodist, Baptist, Pentecostal, Charismatic, Adventist, Evangelical, and more. A space where faith, family values, and genuine connection come together.',
    detail_id: 'Christian Match dirancang untuk jomblo Kristen Protestan yang mencari pasangan yang berbagi iman kepada Kristus. Ini mencakup semua denominasi Protestan — Reformed, Lutheran, Methodist, Baptis, Pantekosta, Karismatik, Advent, Evangelical, dan lainnya. Tempat di mana iman, nilai keluarga, dan koneksi tulus bersatu.',
  },
  {
    name: 'Confucian Match',
    color: '#D97706',
    tiktok: 'konghucumatch.id',
    priority: 6,
    en: 'For singles guided by Confucian values and harmony',
    id: 'Untuk jomblo yang dibimbing nilai Konfusianisme dan harmoni',
    detail_en: 'Confucian Match is for singles who are guided by Confucian values of family, respect, education, and social harmony. This category brings together those who value the principles of ren (benevolence), li (propriety), and xiao (filial piety) in their search for a life partner.',
    detail_id: 'Confucian Match untuk jomblo yang dibimbing nilai-nilai Konfusianisme tentang keluarga, kehormatan, pendidikan, dan harmoni sosial. Kategori ini menyatukan mereka yang menghargai prinsip ren (kebajikan), li (kepatutan), dan xiao (bakti kepada orang tua) dalam pencarian pasangan hidup.',
  },
  {
    name: 'Hindu Match',
    color: '#EF4444',
    tiktok: 'hindumatch.id',
    priority: 7,
    en: 'For Hindu singles honoring tradition and love',
    id: 'Untuk jomblo Hindu yang menghormati tradisi dan cinta',
    detail_en: 'Hindu Match connects Hindu singles who honor their traditions, culture, and spiritual practices. Whether you follow Shaivism, Vaishnavism, Shaktism, or Hindu Dharma Bali traditions, this is a space for those seeking a partner who values dharma, family, and spiritual harmony.',
    detail_id: 'Hindu Match menghubungkan jomblo Hindu yang menghormati tradisi, budaya, dan praktik spiritual mereka. Baik Anda mengikuti Shaivisme, Vaishnavisme, Shaktisme, atau tradisi Hindu Dharma Bali, ini adalah tempat bagi mereka yang mencari pasangan yang menghargai dharma, keluarga, dan keharmonisan spiritual.',
  },
  {
    name: 'Pik Match',
    color: '#EAB308',
    tiktok: 'pik.match',
    priority: 8,
    en: 'For singles living in Pantai Indah Kapuk area',
    id: 'Untuk jomblo yang tinggal di area Pantai Indah Kapuk',
    detail_en: 'Pik Match connects singles living in the Pantai Indah Kapuk (PIK) area of North Jakarta. Known for its modern lifestyle, culinary scene, and strong Chinese-Indonesian community, PIK Match helps you find someone who shares your neighborhood and lifestyle.',
    detail_id: 'Pik Match menghubungkan jomblo yang tinggal di area Pantai Indah Kapuk (PIK) Jakarta Utara. Dikenal dengan gaya hidup modern, kuliner, dan komunitas Tionghoa-Indonesia yang kuat, PIK Match membantu Anda menemukan seseorang yang berbagi lingkungan dan gaya hidup.',
  },
  {
    name: 'BSD Match',
    color: '#06B6D4',
    tiktok: 'bsd.match',
    priority: 9,
    en: 'For singles living in BSD City, Tangerang area',
    id: 'Untuk jomblo yang tinggal di BSD City, area Tangerang',
    detail_en: 'BSD Match is a location-based category for singles living in or around BSD City (Bumi Serpong Damai), Tangerang Selatan. This modern township is home to a vibrant community of young professionals and families. Find your neighbor match and build a connection close to home.',
    detail_id: 'BSD Match adalah kategori berbasis lokasi untuk jomblo yang tinggal di atau sekitar BSD City (Bumi Serpong Damai), Tangerang Selatan. Kota mandiri modern ini merupakan rumah bagi komunitas profesional muda dan keluarga yang dinamis. Temukan jodoh tetangga dan bangun koneksi dekat rumah.',
  },
  {
    name: 'Pelangi Match',
    color: '#8B5CF6',
    tiktok: 'pelangi.match',
    priority: 10,
    en: 'Inclusive matching for the LGBTQ+ community',
    id: 'Perjodohan inklusif untuk komunitas LGBTQ+',
    detail_en: 'Pelangi Match provides a safe and inclusive space for members of the LGBTQ+ community to find meaningful connections. "Pelangi" (rainbow) represents diversity, acceptance, and love without boundaries. All gender identities and sexual orientations are welcome in this category.',
    detail_id: 'Pelangi Match menyediakan ruang yang aman dan inklusif bagi anggota komunitas LGBTQ+ untuk menemukan koneksi bermakna. "Pelangi" merepresentasikan keberagaman, penerimaan, dan cinta tanpa batas. Semua identitas gender dan orientasi seksual diterima di kategori ini.',
  },
  {
    name: 'Ateis Match',
    color: '#64748B',
    tiktok: 'ateis.match',
    priority: 11,
    en: 'For non-religious singles who value reason and connection',
    id: 'Untuk jomblo non-religius yang menghargai akal dan koneksi',
    detail_en: 'Ateis Match is for singles who identify as atheist, agnostic, or spiritual but not religious. This category brings together free thinkers who value reason, science, and genuine human connection over religious dogma. Find someone who shares your worldview.',
    detail_id: 'Ateis Match untuk jomblo yang mengidentifikasi diri sebagai ateis, agnostik, atau spiritual tapi tidak religius. Kategori ini menyatukan pemikir bebas yang menghargai akal, sains, dan koneksi manusia sejati di atas dogma agama. Temukan seseorang yang berbagi pandangan dunia Anda.',
  },
  // ────── Under development (no TikTok yet) ──────
  {
    name: 'Uwiw Match',
    color: '#EC4899',
    tiktok: '',
    priority: 999,
    en: 'For UWIW students and alumni seeking connections',
    id: 'Untuk mahasiswa dan alumni UWIW yang mencari koneksi',
    detail_en: 'Uwiw Match is exclusively for current students and alumni of UWIW (university). Whether you are still studying or have graduated, this category helps you connect with fellow UWIW community members who share your academic background and campus memories.',
    detail_id: 'Uwiw Match khusus untuk mahasiswa aktif dan alumni UWIW (universitas). Baik Anda masih kuliah maupun sudah lulus, kategori ini membantu Anda terhubung dengan sesama anggota komunitas UWIW yang berbagi latar belakang akademis dan kenangan kampus.',
  },
  {
    name: 'IMIP Match',
    color: '#059669',
    tiktok: '',
    priority: 999,
    en: 'For Indonesian singles in Indonesia Morowali Industrial Park',
    id: 'Untuk jomblo Indonesia di Indonesia Morowali Industrial Park',
    detail_en: 'IMIP Match is for singles working or living in and around the Indonesia Morowali Industrial Park (IMIP) in Central Sulawesi. This massive industrial zone attracts workers from all over Indonesia. Find a partner who understands the unique lifestyle of working in this remote yet dynamic area.',
    detail_id: 'IMIP Match untuk jomblo yang bekerja atau tinggal di sekitar Indonesia Morowali Industrial Park (IMIP) di Sulawesi Tengah. Zona industri besar ini menarik pekerja dari seluruh Indonesia. Temukan pasangan yang memahami gaya hidup unik bekerja di area yang terpencil namun dinamis ini.',
  },
  {
    name: 'OZ Match',
    color: '#2563EB',
    tiktok: '',
    priority: 999,
    en: 'For Indonesian singles living in Australia',
    id: 'Untuk jomblo Indonesia yang tinggal di Australia',
    detail_en: 'OZ Match connects Indonesian singles living in Australia (Oz). Whether you are studying, working, or have permanently settled in cities like Sydney, Melbourne, Brisbane, or Perth, this category helps you find a fellow Indonesian diaspora member who shares your experience of living abroad.',
    detail_id: 'OZ Match menghubungkan jomblo Indonesia yang tinggal di Australia (Oz). Baik Anda sedang kuliah, bekerja, atau menetap di kota seperti Sydney, Melbourne, Brisbane, atau Perth, kategori ini membantu Anda menemukan sesama diaspora Indonesia yang berbagi pengalaman tinggal di luar negeri.',
  },
  {
    name: 'Taiwan Match',
    color: '#7C3AED',
    tiktok: '',
    priority: 999,
    en: 'For Indonesian singles living in Taiwan',
    id: 'Untuk jomblo Indonesia yang tinggal di Taiwan',
    detail_en: 'Taiwan Match is for Indonesian singles living in Taiwan — whether as students, migrant workers, or professionals. Taiwan has a large Indonesian community, and this category helps you find connections within your fellow countrymen while navigating life abroad.',
    detail_id: 'Taiwan Match untuk jomblo Indonesia yang tinggal di Taiwan — baik sebagai mahasiswa, pekerja migran, atau profesional. Taiwan memiliki komunitas Indonesia yang besar, dan kategori ini membantu Anda menemukan koneksi dengan sesama WNI saat menjalani kehidupan di luar negeri.',
  },
  {
    name: 'CN Match',
    color: '#E11D48',
    tiktok: '',
    priority: 999,
    en: 'For Indonesian singles living in China',
    id: 'Untuk jomblo Indonesia yang tinggal di China',
    detail_en: 'CN Match connects Indonesian singles living in China — in cities like Shanghai, Beijing, Guangzhou, Shenzhen, and beyond. Whether for work or study, this category helps Indonesians in China find companions who understand the unique challenges and joys of living in the Middle Kingdom.',
    detail_id: 'CN Match menghubungkan jomblo Indonesia yang tinggal di China — di kota seperti Shanghai, Beijing, Guangzhou, Shenzhen, dan lainnya. Baik untuk kerja maupun studi, kategori ini membantu orang Indonesia di China menemukan teman yang memahami tantangan dan kebahagiaan unik tinggal di Tiongkok.',
  },
  {
    name: 'USA Match',
    color: '#1D4ED8',
    tiktok: '',
    priority: 999,
    en: 'For Indonesian singles living in the United States',
    id: 'Untuk jomblo Indonesia yang tinggal di Amerika Serikat',
    detail_en: 'USA Match is for Indonesian singles living in the United States — from New York to Los Angeles, from students to professionals and permanent residents. This category connects the Indonesian-American community for love and meaningful relationships across the country.',
    detail_id: 'USA Match untuk jomblo Indonesia yang tinggal di Amerika Serikat — dari New York hingga Los Angeles, dari mahasiswa hingga profesional dan penduduk tetap. Kategori ini menghubungkan komunitas Indonesia-Amerika untuk cinta dan hubungan bermakna di seluruh negeri.',
  },
  {
    name: 'Hanguk Match',
    color: '#0EA5E9',
    tiktok: '',
    priority: 999,
    en: 'For Indonesians in Korea and Korean natives seeking connection',
    id: 'Untuk orang Indonesia di Korea dan orang Korea yang mencari koneksi',
    detail_en: 'Hanguk Match serves two groups: Indonesians living in South Korea (students, workers, K-culture enthusiasts) and Korean natives interested in connecting with the Indonesian community. "Hanguk" (한국) means Korea, and this category bridges cultures for cross-cultural and same-culture relationships.',
    detail_id: 'Hanguk Match melayani dua kelompok: orang Indonesia yang tinggal di Korea Selatan (mahasiswa, pekerja, penggemar K-culture) dan orang Korea asli yang tertarik terhubung dengan komunitas Indonesia. "Hanguk" (한국) berarti Korea, dan kategori ini menjembatani budaya untuk hubungan lintas budaya dan sesama budaya.',
  },
];

export const CATEGORY_NAMES = CATEGORIES.map(c => c.name);

/**
 * Compute a size tier for the landing-page grid.
 *   large  → priority 1-3
 *   medium → priority 4-8
 *   regular→ priority 9-11
 *   dev    → no tiktok (priority 999)
 */
export function categoryTier(cat) {
  if (!cat.tiktok) return 'dev';
  if (cat.priority <= 3) return 'large';
  if (cat.priority <= 8) return 'medium';
  return 'regular';
}

/** Sorted copy: by priority ascending, dev at the bottom in insertion order. */
export const CATEGORIES_SORTED = [...CATEGORIES].sort((a, b) => (a.priority || 999) - (b.priority || 999));
